import React from "react";
import AdminLayout from "./AdminLayout";
import { Box, Typography } from "@mui/material";

const ReportsPage = () => {
  return (
    <AdminLayout>
      <Box>
        <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
          Reports
        </Typography>
        {/* Copy your renderReports() content from AdminDashboard.js here */}
        <Typography variant="body1" color="text.secondary">
          Reports content - move from AdminDashboard.js
        </Typography>
      </Box>
    </AdminLayout>
  );
};

export default ReportsPage;
